module.exports = __webpack_public_path__ + "static/media/unit.12d0be60.svg";